import {
    REPORT_CONFIGURED_FETCH,
    REPORT_STATUS_FETCH,
    REPORT_CREATE_FETCH,
    REPORT_SELECTED
} from "./reportTypes";

export const initialState = {
    availableReports: {
        fetching: false,
        fetched: false,
        data: null,
        error: null
    },
    reportStatus: {
        fetching: false,
        fetched: false,
        data: null,
        error: null
    },
    reportCreate: {
        fetching: false,
        fetched: false,
        data: null,
        error: null
    },
    reportSelected: {
        index: -2112,
        label: null,
        name: null
    }
};

export default function reportReducer(state = initialState, action) {
    switch (action.type) {
        case REPORT_CONFIGURED_FETCH:
            return {
                ...state,
                availableReports: action.payload
            };
        case REPORT_STATUS_FETCH:
            return {
                ...state,
                reportStatus: action.payload
            };
        case REPORT_CREATE_FETCH:
            return {
                ...state,
                reportCreate: action.payload
            };
        case REPORT_SELECTED:
            return {
                ...state,
                reportSelected: action.payload
            }
        default:
            return state;
    }
};
